<div class="meatball-menu-container" [ngStyle]="{ 'width': listSize < 7 ? '220px' : '450px' }">
  <div class="content">
    <div class="title" *ngIf=" listSize > 0 ">{{ title }}
      <div class="prod-services-links" [ngStyle]="{ 'height': listSize > 6 ? '300px' : '' }">
        <div class="prod-service-item" *ngFor="let link of productServiceList.product.services">
          <a href="{{link.productServiceUrl}}" target="_blank" matTooltip='{{link.productServiceDescription}}'
           [matTooltipPosition]="toolTipPosition"> {{link.productServiceName}} </a>
        </div>
      </div>
    </div>
    <div *ngIf="hasBOCockpit || hasMijnWonen || hasGeldOver">
        <div class="title other-links">Other links</div>
        <div (click)="openCockpit()" class="cockpit-button" *ngIf="hasBOCockpit"> B&O Cockpit </div>
        <div (click)="openMijnWonen()" class="cockpit-button" *ngIf="hasMijnWonen"> Wonen Portaal </div>
        <div (click)="openGeldOverPortaal()" class="cockpit-button" *ngIf="hasGeldOver"> Medewerkers App Geld Over </div>
    </div>
  </div>
</div>
